module.exports = __webpack_public_path__ + "img/luxury-rental-vehicle.d3c4df84.jpg";